<template>
  <div v-title="$route.meta.title"
       class="permission-group">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">权限组选择</span>
      <permission-group-select :disabled="disabled"
                               v-model="permissions"
                               @change="onChange"/>
      <pre>{{disabled}}</pre>
      <pre>{{permissions}}</pre>
    </layout-panel>
  </div>
</template>

<script>
import PermissionGroupSelect from '@/views/permission-group/components/PermissionGroupSelect'

export default {
  components: {PermissionGroupSelect},
  data () {
    return {
      disabled: [4, 6, 14, 2],
      permissions: [4, 6, 14, 2],
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    onChange (val) {
      console.log(val)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-group/pages/PermissionGroupSelectDemo.vue